/**
 * The title of a show is what a person (or the rider) called it - nothing else (SCRUM-833). The venue is its own fact:
 * `shows.venue_id`, named later than the title more often than not, and a derived string is not stored. Where a screen
 * or a letter has no venue line of its own and wants one phrase («Quartet — Harbour Hall»), it is put together HERE,
 * at read time, from the title and the venue's current name - ONE rule for the server (letters, the publish list, the
 * warehouse) and the screens (inbox, print sheet, admin pick, Share). Screens that print the venue beside the title (the
 * worker's page, the rental card, the show page, the calendar) print the title alone.
 *
 * A title that already ends with « — <the venue>» (a row written before SCRUM-833 that the migration has not touched, or a
 * person who wrote it that way) is returned as it is: the venue is not said twice. A pure helper, not a stored shape: the
 * contract version does not move.
 */
export function titleWithVenue(title, venueName) {
    const t = title?.trim();
    if (!t)
        return undefined;
    const v = venueName?.trim();
    if (!v)
        return t;
    return t.endsWith(` — ${v}`) ? t : `${t} — ${v}`;
}
//# sourceMappingURL=show-title.js.map